import { languageMap } from ".."

languageMap.bbj = {
	comments: {
		line: "REM",
	},
}
